import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import VehicleForm from "../components/CompanyVehicles/AddVehicleModal";
import { Modal, Box } from "@mui/material";
import useNotification from "../hooks/notification";
import PageHeader from "../componentsII/PageHeader";
import { useSelector } from "react-redux";
import api from "../axios/api";
import VehicleCard from "../componentsII/Card";
import car from "../images/car.png";
import CompanyVehicleDetailModel from "../components/CompanyVehicles/CompanyVehicleDetailModel";
import { showNotification } from "../redux/slices/notificationSlice";
import Loader from "../componentsII/Loader"
import SettingsModal from "../components/SettingsModal";

import { useDispatch } from "react-redux";
import { fetchCounts } from '../redux/slices/countsSlice';

const CompanyVehicles = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});

  const [vehicles, setVehicles] = useState([]);
  const [inactiveVehicles, setInactiveVehicles] = useState([]);
  const [activeVehicles, setActiveVehicles] = useState([]);

  const [isVehicleLoading, setIsVehicleLoading] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const handleOpenSettingsModal = () => setIsSettingsModalOpen(true);
  const handleCloseSettingsModal = () => { fetchcompanyVehicles(); setIsSettingsModalOpen(false) };

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleOpenDetailModal = () => setIsDetailModalOpen(true);
  const handleCloseDetailModal = () => setIsDetailModalOpen(false);

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);


  useEffect(() => {
    fetchcompanyVehicles();
  }, []);

  const fetchcompanyVehicles = async () => {
    setIsVehicleLoading(true)
    try {
      const response = await api.get(
        `/vehicle/companyVehicle?company_id=${user?.user?.company?.id}&year_id=${year?.id}`
      );
      if (response.data.data) {
        // setVehicles(response.data.data);
        const vehicles = response.data.data.filter(item => item.is_active === 1);

        const activeVehicles = response.data.data.filter(item => item.is_active === 1).map(({ value, label, make_details, model_details, ...rest }) => ({ id:value, name: label, details: `${make_details.make_name} - ${model_details.model_name}`, ...rest, }));
        const inactiveVehicles = response.data.data.filter(item => item.is_active === 0).map(({ value, label, make_details, model_details, ...rest }) => ({ id:value, name: label, details: `${make_details.make_name} - ${model_details.model_name}`, ...rest, }));

        setActiveVehicles(activeVehicles);
        setInactiveVehicles(inactiveVehicles);
        setVehicles(vehicles);

      } else {
        showNotification(response.data.message, "error");
        console.log(response.data.message);
      }
      dispatch(fetchCounts({
        companyId: user.user.company.id,
        yearId: year.id
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsVehicleLoading(false)
  };

  return (
    <PageHeader
      title="Add Vehicle"
      text={[
        "Add your vehicle data. We'll ask you for information such as the vehicle type (e.g. passanger car), amount of fuel used (e.g. 74o liters), an distance driven (e.g. 982 kilometerss).",
      ]}
      buttonTitle="Add Vehicle"
      handleClick={handleOpenModal}
      showBtn2={true}      
      disableBtn2 = {!year.is_copied}
      handleBtn2Click={handleOpenSettingsModal}
      buttonTitle2="Copy Vehicles"
    >
      {isVehicleLoading ? <div className="w-full h-[200px] flex justify-center items-center"><Loader /></div> : vehicles.length === 0 ? (
        <div className="text-center py-16 bg-gray-50 rounded-lg">
          <img
            src="/vectors/Car.jpg"
            alt="No Data"
            className="w-80 h-80 mx-auto text-gray-400 mb-4"
          />
          <h3 className="text-xl font-medium text-gray-600 mb-2">
            No Vehicles Found
          </h3>
          <p className="text-gray-500">Add your first vehicle to get started</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto border grid grid-cols-4 gap-4 p-4">
            {vehicles.map((item) => {
              return (
                <VehicleCard
                  image={car}
                  title={item.label}
                  subtitleI={`${item?.make_details?.make_name} - ${item?.model_details.model_name}`}
                  subtitleII={item?.veh_type_details?.type_name}
                  subtitleIII={item?.veh_subtype_details?.sub_type_name}
                  onClick={() => {
                    handleOpenDetailModal();
                    setDetailModalData({ ...item, car });
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          {/* Close Button */}
          <button
            onClick={handleCloseModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>

          <VehicleForm
            onClose={() => handleCloseModal()}
            refetch={fetchcompanyVehicles}
          />
        </Box>
      </Modal>
      <Modal
        open={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          <button
            onClick={handleCloseDetailModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <CompanyVehicleDetailModel detailModalData={detailModalData} refetch={fetchcompanyVehicles} handleCloseMainDetailModal={handleCloseDetailModal} />
        </Box>
      </Modal>
      <Modal
        open={isSettingsModalOpen}
        onClose={handleCloseSettingsModal}
        aria-labelledby="add-location-modal-title"
        aria-describedby="add-location-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            display: "relative",
          }}
        >
          <button
            onClick={handleCloseSettingsModal}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          <SettingsModal
            ActiveList={activeVehicles}
            InactiveList={inactiveVehicles}
            HelperText={[`Below is the list of vehicles that are active for ${year.start_year} and the list of vehicles available from other reporting years but inactive for the current reporting year.`, "You can add new vehicles to this reporting year from your main vehicles page"]}
            ModalFor="Vehicles"
            Title="Configure Vehicles"
            EmptyActiveText="No Active Vehicles"
            EmptyInactiveText="No Inactive Vehicles"
            EmptyActiveImage={"/vectors/Car.jpg"}
            EmptyInactiveImage={"/vectors/Car.jpg"}
            handleCancel={handleCloseSettingsModal}
          />
        </Box>
      </Modal>
    </PageHeader>
  );
};

export default CompanyVehicles;
